import { config } from "JS/Config";
import { getAudioById } from "JS/Database/Audio";
import { getDexieConnectionRefresh } from "JS/Database/Dexie";
import { ContentWithMedia, GiftWithMedia } from "JS/Models";
import { getDownloadQueueFromStorage } from "./ContentDownloadHelper";

export const getDownloadedPartsNids = async (bundleNid: string) => {
    const bundleCollection = getDexieConnectionRefresh().audios.filter(
        (audio) => audio.isBundle === true,
    );
    let downloadedPartsNids: string[] = [];

    await bundleCollection.keys().then((res) => {
        if (res?.length) {
            // the audios table is keyed on AudioDexie.id, which is a string
            const downloadedBundlePartsNids = res as string[];
            downloadedBundlePartsNids.forEach((nid) => {
                if (nid?.includes(`${config.user.memberId}-${bundleNid}`)) {
                    downloadedPartsNids.push(nid);
                }
            });
        }
    });

    return downloadedPartsNids;
};

export const isBundleInProgress = (nid: string) => {
    const downloadQueue = getDownloadQueueFromStorage();
    let isInQueue = false;
    for (const item of downloadQueue) {
        if (item.nid.includes(nid)) {
            isInQueue = true;
            break;
        }
    }

    return isInQueue;
};

export const isPlaylistDownloaded = async (
    audios: (ContentWithMedia | GiftWithMedia)[],
): Promise<{
    isPartiallyDownloded: boolean;
    isCompleteDownloaded: boolean;
}> => {
    let isPartiallyDownloded = false;
    let isCompleteDownloaded = false;
    const totalItems = audios?.length;

    if (totalItems) {
        const downlaodedAudios = await getDownloadedAudios(audios);
        const downloadedItems = downlaodedAudios?.length;
        if (downloadedItems === totalItems) isCompleteDownloaded = true;
        else if (downloadedItems !== 0) isPartiallyDownloded = true;
    }

    return { isCompleteDownloaded, isPartiallyDownloded };
};
export const getDownloadedAudios = async (
    audios: (ContentWithMedia | GiftWithMedia)[],
): Promise<(ContentWithMedia | GiftWithMedia)[]> => {
    const downloadedAudios: (ContentWithMedia | GiftWithMedia)[] = [];
    const promises: Promise<void>[] = [];
    for (const audio of audios) {
        if (+audio?.no_of_files > 1) {
            const prom = getDownloadedPartsNids(audio?.nid).then((res) => {
                if (res.length === +audio?.no_of_files) {
                    downloadedAudios.push(audio);
                }
            });

            promises.push(prom);
        } else {
            const prom = getAudioById(
                `${config.user.memberId}-${audio?.nid}`,
            ).then((res) => {
                if (res) {
                    downloadedAudios.push(audio);
                }
            });

            promises.push(prom);
        }
    }

    await Promise.all(promises);

    return downloadedAudios;
};
